import '../../../filtersGrid.scss';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useMediaQuery } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import TextField from '@mui/material/TextField';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import EmpleadosModal from '../../../empleados/empleadosModal/empleadosModal';
import ClientesModal from '../../../clientes/clientesModal/clientesModal';

Modal.setAppElement('#root');
dayjs.locale('es');

// ─── Picker base compartido ───────────────────────────────────────────────────
const pickerSlotProps = (minWidth) => ({
  textField: { size: 'small', sx: { minWidth } },
});

const FiltersGrid = ({
  setSearchIDFilter,
  setSearchDescFilter,
  searchDescFilter,
  setSearchSecondIDFilter,
  setSearchSecondDescFilter,
  searchSecondDescFilter,
  dateFromFilter,
  setDateFromFilter,
  dateUntilFilter,
  setDateUntilFilter,
  hourFromFilter,
  setHourFromFilter,
  hourUntilFilter,
  setHourUntilFilter,
  searchPedidoFilter,
  setSearchPedidoFilter,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  // Cerrar modal automáticamente al agrandar la pantalla
  useEffect(() => {
    if (!isSmallScreen) setIsModalOpen(false);
  }, [isSmallScreen]);

  const handleClearFilters = () => {
    setSearchIDFilter?.('');
    setSearchDescFilter?.('');
    setSearchSecondIDFilter?.('');
    setSearchSecondDescFilter?.('');
    setDateFromFilter?.(null);
    setDateUntilFilter?.(null);
    setHourFromFilter?.(null);
    setHourUntilFilter?.(null);
    setSearchPedidoFilter?.('');
  };

  // ── Bloque de fechas y horas ─────────────────────────────────────────────
  const renderDateInputs = () => (
    <>
      {/* Desde */}
      <div className="filtro-item fecha">
        <DatePicker
          label="Fecha desde"
          value={dateFromFilter ? dayjs(dateFromFilter) : null}
          onChange={setDateFromFilter}
          inputFormat="DD/MM/YYYY"
          renderInput={(params) => <TextField {...params} size="small" sx={{ minWidth: 100 }} />}
        />
      </div>
      <div className="filtro-item hora">
        <TimePicker
          value={hourFromFilter}
          onChange={setHourFromFilter}
          ampm={false}
          renderInput={(params) => <TextField {...params} size="small" sx={{ minWidth: 100 }} />}
        />
      </div>

      {/* Hasta */}
      <div className="filtro-item fecha">
        <DatePicker
          label="Fecha hasta"
          value={dateUntilFilter ? dayjs(dateUntilFilter) : null}
          onChange={setDateUntilFilter}
          inputFormat="DD/MM/YYYY"
          renderInput={(params) => <TextField {...params} size="small" sx={{ minWidth: 100 }} />}
        />
      </div>
      <div className="filtro-item hora">
        <TimePicker
          value={hourUntilFilter}
          onChange={setHourUntilFilter}
          ampm={false}
          renderInput={(params) => <TextField {...params} size="small" sx={{ minWidth: 100 }} />}
        />
      </div>
    </>
  );

  // ── Filtros de búsqueda (cliente, empleado, estado) ──────────────────────
  const renderSearchInputs = () => (
    <>
      <ClientesModal
        handleChange={setSearchIDFilter}
        handleDescChange={setSearchDescFilter}
        descSelected={searchDescFilter}
      />

      <EmpleadosModal
        handleChange={setSearchSecondIDFilter}
        handleDescChange={setSearchSecondDescFilter}
        descSelected={searchSecondDescFilter}
      />

      <div className="filtro-item pedido-status">
        <select
          value={searchPedidoFilter}
          onChange={(e) => setSearchPedidoFilter(e.target.value)}
        >
          <option value="">Seleccionar estado</option>
          <option value="0">Con Pedido</option>
          <option value="1">Sin Pedido</option>
        </select>
      </div>
    </>
  );

  // ── Todos los filtros juntos ─────────────────────────────────────────────
  const renderFilters = () => (
    <>
      {renderDateInputs()}
      {renderSearchInputs()}
    </>
  );


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <div className="filterContainer">

        {isSmallScreen ? (
          /* ── MOBILE: botón que abre modal ─────────────────────────────── */
          <>
            <button className="filterButton" onClick={() => setIsModalOpen(true)}>
              <TuneIcon style={{ fontSize: 16 }} />
              Filtros de búsqueda
            </button>

            <Modal
              isOpen={isModalOpen}
              onRequestClose={() => setIsModalOpen(false)}
              className="modalScreen"
              overlayClassName="overlayScreen"
            >
              {/* Header del modal */}
              <div className="modalScreen__header">
                <span className="modalScreen__title">Filtros de búsqueda</span>
                <button
                  className="modalScreen__close"
                  onClick={() => setIsModalOpen(false)}
                  aria-label="Cerrar"
                >
                  <CloseIcon style={{ fontSize: 18 }} />
                </button>
              </div>

              {/* Contenido */}
              <div className="modalContent">
                {renderFilters()}
              </div>
              <div className="filtersActions">
                <button
                  type="button"
                  className="clearFiltersButton"
                  onClick={handleClearFilters}
                >
                  Limpiar filtros
                </button>
              </div>
            </Modal>
          </>
        ) : (
          /* ── DESKTOP: filtros inline ──────────────────────────────────── */
          <>

            <div className="searchContainer">
              {renderFilters()}
              <div className="filtersActions">
                <button
                  type="button"
                  className="clearFiltersButton"
                  onClick={handleClearFilters}
                >
                  Limpiar filtros
                </button>
              </div>
            </div >
          </>
        )}

      </div>
    </LocalizationProvider>
  );
};

export default FiltersGrid;